/*
 * Find Product Tile allowed Image base on config
 *
 * @param {string} allowedImages
 * @param {array} images
 */
const getAllowedImageTypes = (allowedImages, images = []) => {
  const sizesLength = images?.length;
  let result;

  if (typeof allowedImages !== 'string' || allowedImages.trim() === '' || !sizesLength) {
    return undefined;
  }

  allowedImages.split('|')?.some(keyString => {
    if (typeof keyString !== 'string') return false;

    const normalizedKey = keyString.trim().toUpperCase();
    if (normalizedKey === '') return false; // Skip empty keys

    const image = images.find(
      img =>
        // Ensure img.key is a string and normalize for case-insensitive comparison
        typeof img?.key === 'string' && img.key.trim().toUpperCase() === normalizedKey
    );
    if (image) {
      result = image;

      return true; // Found the image, stop .some() iteration
    }

    return false; // Continue .some() iteration
  });

  return result;
};

export default getAllowedImageTypes;
